module.exports = __webpack_public_path__ + "static/img/amazon.c67867f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/amenities/facilities/amazon.jpg
// module id = 588
// module chunks = 0